import { Icon, IconSize, CloseSmall } from '@soteria/design-system-ve';

import * as styles from './ClearButton.css';

interface ClearButtonProps {
  /**
   * Accessible label for screen readers
   */
  ariaLabel: string;
  /**
   * Tooltip text shown on hover
   */
  title?: string;
  /**
   * Click handler
   */
  onClick: () => void;
}

/**
 * ClearButton component for input fields
 * Provides consistent clear button styling and accessibility across input cards
 */
export function ClearButton({ ariaLabel, title, onClick }: ClearButtonProps) {
  return (
    <button aria-label={ariaLabel} className={styles.clearButton} title={title} type="button" onClick={onClick}>
      <Icon icon={CloseSmall} iconSize={IconSize.XSmall} />
    </button>
  );
}
